module.exports = __webpack_public_path__ + "static/media/drgcc-aerial-views.abf58eb6.jpg";